import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth/auth.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  constructor(
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.authService.checkAuth();
  }
}
